import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";


export interface ILanguageFormMeta {
    language: FormInputMeta;
    level: FormInputMeta;
    schema: any;
  }

const LanguageFormMeta = {} as ILanguageFormMeta;

LanguageFormMeta.language = {
    label: 'Language',
    name: 'language',
    type: 'select',
    placeholder: 'Select ...',
    options:  [
      {
        label: 'Language 1',
        value: '1'
      },
      {
        label: 'Language 2',
        value: '2',
      },
      {
        label: 'Language 3',
        value: '3',
      },
    ],   
    validation: yup.string().required(),
}

LanguageFormMeta.level = {
    label: 'Niveau',
    name: 'level',
    type: 'select',
    placeholder: 'Select ...',
    options:  [
      {
        label: 'Niveau 1',
        value: '1'
      },
      {
        label: 'Niveau 2',
        value: '2',
      },
      {
        label: 'Niveau 3',
        value: '3',
      },
    ],
    validation: yup.string().required(),
}


LanguageFormMeta.schema = yup.object().shape(getValidationSchema(LanguageFormMeta));

export default LanguageFormMeta;